/* exported helpers */
/*
    Object containing all global helper functions to make writing
    and working with JavaScript a little easier

    New functions should be added to the bottom of the object and
    commented appropriately (i.e. usage, etc.)
 */
var helpers = {

    /*
     * Returns the active language
     *
     * @param none
     */
    getLang: function() {
        var lang;
        if (jQuery('html').attr('lang') === 'en-US') {
            lang = 'en';
        } else {
            lang = 'fr';
        }

        return lang;
    },

    /*
     * Returns the current page / post's ID
     *
     * @param none
     */
    getPostID: function() {
        // Get all classes
        var classes = document.body.className.split(/\s+/);

        // Iterate over classes
        for (var i = 0; i < classes.length; i++) {
            // If post ID exists in one, return it
            if (classes[i].indexOf('postid') !== -1) {
                return parseInt(classes[i].split('-')[1]);
            }
        }

        // No post ID
        return false;
    },

    /*
     * Checks if a provided element is currently visible in the viewport
     *
     * @param {Object} ele - the provided element to check (jQuery or JS ref)
     */
    inViewport: function(ele) {
        // Do nothing if not a jQuery object
        if (!(ele instanceof jQuery)) {
            return;
        }

        // Get viewport distances
        var viewport = {
            top: jQuery(window).scrollTop(),
            left: jQuery(window).scrollLeft(),
            right: jQuery(window).scrollLeft() + jQuery(window).width(),
            bottom: jQuery(window).scrollTop() + jQuery(window).height()
        };

        // Get element bounds
        var bounds = ele.offset();
        bounds.right = bounds.left + ele.outerWidth();
        bounds.bottom = bounds.top + ele.outerHeight();

        // Check and return
        return (!(
            viewport.right < bounds.left ||
            viewport.left > bounds.right ||
            viewport.bottom < bounds.top ||
            viewport.top > bounds.bottom
        ));
    },

    /*
     * Limits event-driven performance so they don't get fired too often, such
     * as resize or keypress events. This function waits for a given timeout to complete
     * before triggering the associated event
     *
     * Usage: var myFunc = debounce(function() { ... }, 250);
     *
     * @param {function} func - the function to debounce
     * @param {int} wait - how long to wait before firing
     */
    debounce: function(callback, delay) {
        // Store timeout variable
        var timeout;

        // Create closure
        return function() {
            // Store necessary properties
            var context = this;
            var args = arguments;

            // Reset the timer
            clearTimeout(timeout);

            // Set the timer
            timeout = setTimeout(function() {
                callback.apply(context, args);
            }, delay);
        };
    }
};
